import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { TextLoca } from "../generic/text/TextLoca";
export var ImprovementLockedLevelStatus = function (_a) {
    var level = _a.level, loca = _a.loca;
    var locaReplacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(level)]]);
    return (React.createElement("div", { className: "flex flex--guts flex__full" },
        React.createElement(TextLoca, { id: loca, replacements: locaReplacements, className: IdStyles.TextNormal })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/ImprovementLockedLevelStatus.tsx
// module id = 2692
// module chunks = 3